import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, extractError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            // 401 on first load is expected when unauthenticated; other errors we log.
            if (e?.response?.status !== 401) console.error("Auth refresh failed:", e);
            setUser(null);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (e) {
            console.error("Logout request failed:", e);
        }
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, login, logout, refresh, extractError }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
